import React from 'react'
import { render } from 'react-snapshot'
import FastClick from 'fastclick'

import App from './App/App.js'
import 'normalize.css'
import './css/vars.css'
import './css/base.css'
import './css/utils.css'

FastClick.attach(document.body)

render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js